import React, {useEffect, useRef, useState} from "react";
import SurveyAssistantMessageText from "./SurveyAssistantMessageText";
import LoadingIndicatorThreeDots from "./LoadingIndicatorThreeDots";
import UserIconName from "./UserIconName";

import {DateTime} from "luxon";

function SurveyAssistantMessageBox(props) {
    let {text, type, createdDate, awaitingText, internetSearchText, handleRetrySendMessage, error} = props;

    const isUserTypeMessage = type === "user_input";
    let formattedText = typeof text === "undefined" ? "" : text.replace(/\r\n|\r|\n/g, '  \n');

    const userEmail = "JD";

    const [expandedText, setExpandedText] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef(null);
    const MAX_MESSAGE_HEIGHT = 300;

    const toggleExpand = () => setExpandedText(prev => !prev);

    useEffect(() => {
        if (contentRef.current) {
            // Detect whether the content is overflowing
            setIsOverflowing(contentRef.current.scrollHeight > contentRef.current.clientHeight);
        }
    }, [formattedText]);

    return (
        <div className={"message " + (isUserTypeMessage ? " message-out " : "")}>
            <div className="avatar avatar-responsive only-mobile">
                {isUserTypeMessage
                    ? <UserIconName userEmail={userEmail} diameter={40}/>
                    : <img src="/assets/img/site/logo-avatar.png" width="35"
                           height="35" className="avatar-img" alt="avatar"/>
                }
            </div>
            <div className="message-inner">
                <div className="message-body">
                    <div className="message-content">
                        <div className={`message-text ${awaitingText ? 'fst-italic text-muted' : ''}`}>
                            <div className="message-text-only"
                                 ref={contentRef}
                                 style={{
                                     maxHeight: expandedText ? "none" : "50vh",
                                     overflow: expandedText ? "visible" : "hidden",
                                     position: "relative",
                                     transition: "max-height 0.3s ease-in-out",
                                 }}>

                                {error ?
                                    (
                                        <>
                                            <p style={{color: "red"}}>{formattedText}</p>
                                            <a href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   handleRetrySendMessage()
                                               }}
                                               className="btn btn-primary text-white"
                                            >Retry?</a>
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            {!!formattedText &&
                                                <SurveyAssistantMessageText text={formattedText}/>

                                            }
                                            {!!awaitingText &&
                                                <p>
                                                    <p style={{display: "inline"}}>
                                                        {awaitingText}
                                                    </p>
                                                    <div style={{display: "inline", marginLeft: "10px"}}>
                                                        <LoadingIndicatorThreeDots/>
                                                    </div>
                                                </p>
                                            }
                                            {!!internetSearchText &&
                                                <SurveyAssistantMessageText text={internetSearchText}/>
                                            }
                                        </>
                                    )}
                            </div>

                            {/* BUTTON - Always Visible Below the Text */}
                            {isOverflowing && (
                                <div style={{
                                    textAlign: "center",
                                    paddingTop: "5px"
                                }}>
                                    <button
                                        className={"btn " + (isUserTypeMessage ? "btn-primary text-white" : "btn-link")}
                                        onClick={toggleExpand}
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            textDecoration: "none",
                                        }}
                                    >
                                        {expandedText ? "See Less ▲" : "See More ▼"}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="message-footer">
                    {!!createdDate &&
                        <span className="extra-small text-muted">
                            {DateTime.fromMillis(createdDate).toLocaleString(DateTime.DATETIME_MED)}
                        </span>
                    }
                </div>
            </div>
        </div>
    );
}

export default SurveyAssistantMessageBox;